import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import SolutionsPage from './pages/SolutionsPage';
import AllProductsPage from './pages/AllProductsPage';
import OfficeSpacePage from './pages/OfficeSpacePage';
import CoworkingPage from './pages/CoworkingPage';
import VirtualOfficePage from './pages/VirtualOfficePage';
import MeetingRoomsPage from './pages/MeetingRoomsPage';
import BusinessAddressesPage from './pages/BusinessAddressesPage';
import PrivateOfficesPage from './pages/PrivateOfficesPage';
import DayOfficesPage from './pages/DayOfficesPage';
import FlexibleWorkspacePage from './pages/FlexibleWorkspacePage';
import GalleryPage from './pages/GalleryPage';
import ChatBot from './components/ChatBot';
import WhatsAppButton from './components/WhatsAppButton';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <div className="App">
      <HashRouter>
        {/* ScrollToTop component - automatically scrolls to top on route change */}
        <ScrollToTop />
        
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/solutions" element={<SolutionsPage />} />
          <Route path="/products" element={<AllProductsPage />} />
          <Route path="/office-space" element={<OfficeSpacePage />} />
          <Route path="/coworking" element={<CoworkingPage />} />
          <Route path="/virtual-office" element={<VirtualOfficePage />} />
          <Route path="/meeting-rooms" element={<MeetingRoomsPage />} />
          <Route path="/business-addresses" element={<BusinessAddressesPage />} />
          <Route path="/private-offices" element={<PrivateOfficesPage />} />
          <Route path="/day-offices" element={<DayOfficesPage />} />
          <Route path="/flexible-workspace" element={<FlexibleWorkspacePage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
        </Routes>
        
        {/* WhatsApp Button - Fixed position above ChatBot */}
        <WhatsAppButton />
        
        {/* Global ChatBot - Available on all pages */}
        <ChatBot />
      </HashRouter>
    </div>
  );
}

export default App;